import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseText, BaseView } from '@/components/base'
import { Modal } from '@/components/Modal'
import { AppButton } from '@/components/AppButton'
import { responsiveAdapterVertical } from '@/utils'
import useOffsets from '@/hooks/useOffsets'

export const ValidationByFeatureFooter: React.FC = () => {
  const { t } = useTranslation()
  const offsets = useOffsets()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handlePress = () => {
    // TODO: Implement bottom sheet or modal for "why we need this info"
  }

  return (
    <>
      <BaseView
        style={{ marginTop: 'auto', marginBottom: 12, justifySelf: 'flex-end' }}
        center
      >
        <BaseText
          style={{
            fontSize: 16,
            fontWeight: '600',
            cursor: 'pointer',
          }}
          color="label.semiTransparent"
          onClick={() => setIsModalOpen(true)}
        >
          {t('translation:validationsByFeature.whyWeNeedThisInfo')}
        </BaseText>
      </BaseView>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <BaseView style={{ paddingBottom: offsets.bottom }}>
          <BaseText fontSize={28} textAlign="center" fontFamily="semibold">
            {t('translation:validationsByFeature.whyWeNeedThisInfo')}
          </BaseText>
          <BaseText
            fontSize={16}
            textAlign="center"
            fontFamily="regular"
            color="label.description"
            lineHeight={20}
          >
            {t('bottomSheets:necessaryChecks.description')}
          </BaseText>
          <br />
          <BaseText
            fontSize={16}
            textAlign="center"
            fontFamily="regular"
            color="label.description"
            lineHeight={20}
            style={{ marginBottom: responsiveAdapterVertical(16) }}
          >
            {t('bottomSheets:necessaryChecks.seeMoreInOur')}
            <a
              href="http://kemapp.io/policies/privacy-policy"
              target="_blank"
              style={{
                textDecoration: 'underline',
                cursor: 'pointer',
                color: 'white',
              }}
              rel="noreferrer"
            >
              {t('links:privacyPolicy')}
            </a>
          </BaseText>
          <AppButton
            label={t('form:actions.okay')}
            type="secondaryGray"
            onPress={() => {
              setIsModalOpen(false)
            }}
          />
        </BaseView>
      </Modal>
    </>
  )
}
